import { render, staticRenderFns } from "./сreate-channel-card.vue?vue&type=template&id=6b35608d&scoped=true"
import script from "./сreate-channel-card.vue?vue&type=script&lang=ts"
export * from "./сreate-channel-card.vue?vue&type=script&lang=ts"
import style0 from "./сreate-channel-card.vue?vue&type=style&index=0&id=6b35608d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35608d",
  null
  
)

export default component.exports